import React from 'react';
import { AlertModalState } from '../../types/dispense';

interface AlertModalProps {
  alertModal: AlertModalState;
  onDismiss: () => void;
}

export function AlertModal({ alertModal, onDismiss }: AlertModalProps) {
  if (!alertModal.show) return null;

  return (
    <div className="modal-overlay" onClick={onDismiss} style={{ zIndex: 3000 }}>
      <div className="modal modal-alert" onClick={(e) => e.stopPropagation()}>
        <div className={`alert-icon alert-icon-${alertModal.type || 'info'}`}>
          {alertModal.type === 'success' && '✓'}
          {alertModal.type === 'error' && '✕'}
          {(!alertModal.type || alertModal.type === 'info') && 'ℹ'}
        </div>
        <div className="alert-message">{alertModal.message}</div>
        <div className="modal-actions">
          <button
            className={`btn ${alertModal.type === 'success' ? 'btn-success' : alertModal.type === 'error' ? 'btn-danger' : 'btn-primary'}`}
            onClick={onDismiss}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
}
